import { 
    AttachedFileLogo, 
    FileAttachmentFrame, 
    FileIconAndNameWrapper, 
    FileName 
} from "./FileAttachment.styled";
import { FileOptionsPopover } from "./FileOptionsPopover/FileOptionsPopover";

interface FileWithinNoteProps {
    file: File;
    annotationID: string;
}

export const FileWithinNote = ({file, annotationID}: FileWithinNoteProps) => {
    return (
        <FileAttachmentFrame contentEditable={false} style={{width: "98%"}}>
            <FileIconAndNameWrapper >
                <AttachedFileLogo />
                <FileName style={{alignSelf: 'center'}}>{file.name}</FileName>
            </FileIconAndNameWrapper>
            <FileOptionsPopover file={file} annotationID={annotationID}/>
        </FileAttachmentFrame>
    );
}